import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import TextField from 'components/fields/TextField';
import IconButton from 'components/common/IconButton';
import IconPen from 'components/icons/IconPen';

const styles = theme => ({
  root: {
    position: 'relative',
  },
  typography: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  textField: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    marginTop: 5,
    marginBottom: 6,
  },
  button: {
    color: theme.palette.primary.A400,
  },
  iconPen: {
    width: 16,
    height: 16,
  },
  iconPenError: {
    color: theme.palette.validation[500],
  },
  typographyError: {
    color: theme.palette.validation[500],
  },
  gridItemShrink: {
    flexShrink: 1,
    minWidth: 0,
  },
  previewEdit: {
    visibility: 'hidden',
    opacity: 0,
  },
});

class EditTextField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: props.edit,
    };

    this.onEditButtonClick = this.onEditButtonClick.bind(this);
    this.onTextFieldBlur = this.onTextFieldBlur.bind(this);
    this.onTextFieldKeyDown = this.onTextFieldKeyDown.bind(this);
  }

  onEditButtonClick() {
    this.setState({ edit: true });
  }

  onTextFieldBlur() {
    if (!this.props.edit) {
      this.setState({ edit: false });
    }
  }

  onTextFieldKeyDown(event) {
    if (this.props.edit && event.key === 'Enter') {
      this.setState({ edit: false });
    }
    this.props.onKeyDown(event);
  }

  render() {
    const {
      input,
      meta,
      placeholder,
      classes,
      ...otherProps
    } = this.props;
    const { edit } = this.state;
    return (
      <div className={classes.root}>
        <div
          className={classNames({ [classes.previewEdit]: edit })}
          {...edit ? { role: 'presentation' } : {}}
        >
          <Grid
            container
            spacing={0}
            alignItems="center"
            justify="space-between"
            wrap="nowrap"
          >
            <Grid className={classes.gridItemShrink} item>
              <Typography
                variant="subheading"
                className={classNames(classes.typography, {
                  [classes.typographyError]: meta.error && meta.touched,
                })}
              >
                {input.value || placeholder}
              </Typography>
            </Grid>
            <Grid item>
              <IconButton
                className={classes.button}
                onClick={this.onEditButtonClick}
                tooltipContent="Edit"
              >
                <IconPen
                  className={classNames(classes.iconPen, {
                    [classes.iconPenError]: meta.error && meta.touched,
                  })}
                />
              </IconButton>
            </Grid>
          </Grid>
        </div>
        {edit &&
          <TextField
            className={classes.textField}
            input={input}
            meta={meta}
            id={input.name}
            color="light"
            onBlur={this.onTextFieldBlur}
            inputRef={(inputRef) => {
              if (inputRef) {
                inputRef.focus();
                inputRef.setSelectionRange(input.value.length, input.value.length);
              }
            }}
            placeholder={placeholder}
            {...otherProps}
            onKeyDown={this.onTextFieldKeyDown}
            fullWidth
          />
        }
      </div>
    );
  }
}

EditTextField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }).isRequired,
  placeholder: PropTypes.string,
  onKeyDown: PropTypes.func,
  edit: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
    textField: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    iconPen: PropTypes.string.isRequired,
    iconPenError: PropTypes.string.isRequired,
    typographyError: PropTypes.string.isRequired,
    gridItemShrink: PropTypes.string.isRequired,
  }).isRequired,
};

EditTextField.defaultProps = {
  placeholder: '',
  onKeyDown: () => {},
  edit: false,
};

export default withStyles(styles)(EditTextField);



// WEBPACK FOOTER //
// ./src/components/fields/EditTextField.js